import { useQuery } from '@tanstack/react-query';
import type { ProductDetail } from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const productQueryKey = (productId: string) =>
  ['admin', 'product', productId] as const;

export const useProductQuery = (productId: string | undefined) =>
  useQuery<ProductDetail>({
    queryKey: productQueryKey(productId ?? ''),
    enabled: Boolean(productId),
    queryFn: async () => {
      const [data] = await apiClient.request(
        'get',
        '/admin/v1/products/{productId}',
        {
          params: { path: { productId: productId as string } },
        },
      );
      return data as ProductDetail;
    },
  });
